import { createSlice } from '@reduxjs/toolkit';
import {
  deleteDiagnosis,
  fetchDiagnoses,
  insertDiagnoses,
  searchDiagnoses,
  updateDiagnosis,
} from './actions';
import { Diagnosis } from './models/Diagnosis';
import { DiagnosisSearchResult } from './models/DiagnosisSearchResult';

export interface DiagnosisState {
  diagnoses: Diagnosis[];
  loadingDiagnoses: boolean;
  loadingInsertDiagnoses: boolean;
  diagnosesSearchResult: DiagnosisSearchResult[];
  loadingSearchDiagnoses: boolean;
}

const initialState: DiagnosisState = {
  diagnoses: [],
  loadingDiagnoses: false,
  loadingInsertDiagnoses: false,
  diagnosesSearchResult: [],
  loadingSearchDiagnoses: false,
};

const diagnosisSlice = createSlice({
  name: 'diagnosis',
  initialState,
  reducers: {
    clearDiagnosisSearchResults: (state) => {
      state.diagnosesSearchResult = [];
    },
    clearDiagnoses: (state) => {
      state.loadingDiagnoses = true;
      state.diagnoses = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchDiagnoses.pending, (state) => {
        state.loadingSearchDiagnoses = true;
      })
      .addCase(searchDiagnoses.fulfilled, (state, action) => {
        state.diagnosesSearchResult = action.payload;
        state.loadingSearchDiagnoses = false;
      })
      .addCase(searchDiagnoses.rejected, (state) => {
        state.diagnosesSearchResult = [];
        state.loadingSearchDiagnoses = false;
      })
      .addCase(insertDiagnoses.fulfilled, (state) => {
        state.loadingInsertDiagnoses = false;
      })
      .addCase(insertDiagnoses.pending, (state) => {
        state.loadingInsertDiagnoses = true;
      })
      .addCase(insertDiagnoses.rejected, (state) => {
        state.loadingInsertDiagnoses = false;
      })
      .addCase(fetchDiagnoses.fulfilled, (state, action) => {
        state.diagnoses = action.payload;
        state.loadingDiagnoses = false;
      })
      .addCase(fetchDiagnoses.rejected, (state) => {
        state.loadingDiagnoses = false;
      })
      .addCase(fetchDiagnoses.pending, (state) => {
        state.loadingDiagnoses = true;
      })
      .addCase(updateDiagnosis.fulfilled, (state, action) => {
        const updatedSymptoms = state.diagnoses.map((diagnosis) =>
          diagnosis.id === action.payload.id ? action.payload : diagnosis
        );
        state.diagnoses = updatedSymptoms;
      })
      .addCase(deleteDiagnosis.fulfilled, (state, action) => {
        state.diagnoses = state.diagnoses.filter(
          (diagnosis) => diagnosis.id !== action.meta.arg
        );
      });
  },
});

export const { clearDiagnosisSearchResults, clearDiagnoses } =
  diagnosisSlice.actions;

export default diagnosisSlice.reducer;
